// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b7b5f20","239":"47514710","453":"c5aa5615","732":"bce19d2e"}[chunkId] + ".chunk.js";
};